/* Monsor creator video's: altijd zichtbare scrollbar + soepel verticaal-naar-horizontaal wiel.
   Extern geladen via layout zodat het ook met page-transitions betrouwbaar draait.
   Klasse-gebaseerd en idempotent (geen sectie-id nodig). */
(function () {
  function clampv(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function initRow(row) {
    if (row.__mcvBarInit) return;
    var wrap = row.closest('.mcv') || row.parentElement;
    var bar = wrap ? wrap.querySelector('[data-mcv-scroll]') : null;
    var thumb = bar ? bar.querySelector('[data-mcv-thumb]') : null;
    if (!bar || !thumb) return;
    row.__mcvBarInit = true;

    function render() {
      var scrollable = row.scrollWidth - row.clientWidth;
      if (scrollable <= 2) { if (row.clientWidth > 0) bar.setAttribute('hidden', ''); return; }
      bar.removeAttribute('hidden');
      var trackW = bar.clientWidth;
      if (trackW <= 0) return;
      var ratio = row.clientWidth / row.scrollWidth;
      var tw = Math.max(36, Math.min(Math.round(trackW * ratio), Math.round(trackW * 0.45)));
      if (tw > trackW) tw = trackW;
      thumb.style.width = tw + 'px';
      var maxT = trackW - tw;
      var pos = maxT > 0 ? (row.scrollLeft / scrollable) * maxT : 0;
      thumb.style.transform = 'translateX(' + Math.round(pos) + 'px)';
    }

    var raf = null, animating = false, target = row.scrollLeft;
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } animating = false; }
    function anim() {
      var c = row.scrollLeft, d = target - c;
      if (Math.abs(d) < 0.5) { row.scrollLeft = target; render(); stop(); return; }
      row.scrollLeft = c + d * 0.18; render();
      raf = requestAnimationFrame(anim);
    }
    function start() { if (!animating) { animating = true; raf = requestAnimationFrame(anim); } }

    row.addEventListener('scroll', function () { if (!animating) render(); }, { passive: true });
    window.addEventListener('resize', render);
    if (typeof ResizeObserver === 'function') { try { new ResizeObserver(render).observe(row); } catch (e) {} }
    var media = row.querySelectorAll('img, video');
    for (var i = 0; i < media.length; i++) {
      media[i].addEventListener('load', render);
      media[i].addEventListener('loadedmetadata', render);
    }

    row.addEventListener('wheel', function (e) {
      var scrollable = row.scrollWidth - row.clientWidth;
      if (scrollable <= 2) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var atS = row.scrollLeft <= 0, atE = row.scrollLeft >= scrollable - 1;
      if ((e.deltaY < 0 && atS) || (e.deltaY > 0 && atE)) { stop(); return; }
      e.preventDefault();
      target = clampv((animating ? target : row.scrollLeft) + e.deltaY, 0, scrollable);
      start();
    }, { passive: false });

    var dragging = false, sx = 0, ss = 0;
    thumb.addEventListener('pointerdown', function (e) {
      stop(); dragging = true; sx = e.clientX; ss = row.scrollLeft;
      try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });
    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var maxT = bar.clientWidth - thumb.clientWidth, scrollable = row.scrollWidth - row.clientWidth;
      if (maxT <= 0) return;
      row.scrollLeft = clampv(ss + ((e.clientX - sx) / maxT) * scrollable, 0, scrollable);
      target = row.scrollLeft; render();
    });
    function endDrag(e) { dragging = false; try { thumb.releasePointerCapture(e.pointerId); } catch (_) {} }
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    bar.addEventListener('pointerdown', function (e) {
      if (e.target === thumb) return;
      stop();
      var rect = bar.getBoundingClientRect(), tw = thumb.clientWidth, maxT = bar.clientWidth - tw, scrollable = row.scrollWidth - row.clientWidth;
      if (maxT <= 0) return;
      var tgt = clampv((e.clientX - rect.left) - tw / 2, 0, maxT);
      row.scrollLeft = (tgt / maxT) * scrollable; target = row.scrollLeft; render();
    });

    render();
    setTimeout(render, 100);
    setTimeout(render, 400);
    setTimeout(render, 1000);
  }

  function initAll() {
    var rows = document.querySelectorAll('.mcv__row');
    for (var n = 0; n < rows.length; n++) initRow(rows[n]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('page:loaded', initAll);
  document.addEventListener('shopify:section:select', initAll);

  // Vang rijen op die later in de DOM verschijnen (page-transitions, lazy render).
  if (typeof MutationObserver === 'function') {
    try {
      var mo = new MutationObserver(function () { initAll(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
})();